import {Route, Routes, useLocation} from 'react-router-dom'
import {PrivateRoute} from "./ProtectedRoute.tsx";
import {PublicRoute} from "./PublicRoute.tsx";
import {Login} from "../pages/login/Login.tsx";
import {MyProfile} from "../pages/profile/MyProfile.tsx";
import {Messages} from "../pages/messages/Messages.tsx";
import {CandidateMsgDetails} from "../pages/candidateMsgDetails/CandidateMsgDetails.tsx";
import {Account} from "../pages/account/Account.tsx";
import {Recommendation} from "../pages/recomentation/Recomendation.tsx";
import {Templates} from "../pages/templates/Templates.tsx";
import {Privacy} from "../pages/privacy/Privacy.tsx";
import {HilfeKontakt} from "../pages/hilfeKontakt/HilfeKontakt.tsx";
import {Searches} from "../pages/searches/Searches.tsx";
import {EditSearch} from "../pages/editSearch/EditSearch.tsx";
import {JobDetails} from "../pages/jobDetails/JobDetails.tsx";
import {Personal} from "../pages/profile/subPages/Personal.tsx";
import {DesiredJobs} from "../pages/profile/subPages/DesiredJobs.tsx";
import {Location} from "../pages/profile/subPages/Location.tsx";
import {Education} from "../pages/profile/subPages/Education.tsx";
import {WorkHistory} from "../pages/profile/subPages/WorkHistory.tsx";
import {CVDocument} from "../pages/profile/subPages/CVDocument.tsx";
import {DeleteProfile} from "../pages/deleteProfile/DeleteProfile.tsx";
import {MagicLinkRedirect} from "../pages/magicLink/MagicLinkRedirect.tsx";
import {ErrorState} from "../components/ErrorState.tsx";
import {Courses} from "../pages/courses/Courses.tsx";
import {CourseDetails} from "../pages/courseDetails/CourseDetails.tsx";
import {JobPoolNew} from "../pages/jobPool/JobPoolNew.tsx";
import {AiJobs} from "../pages/aiJobs/AiJobs.tsx";
import {AiNewJobs} from "../pages/aiNewJobs/AiNewJobs.tsx";
import {CoverLetter} from "../pages/coverLetter/CoverLetter.tsx";
import {Interview} from "../pages/interview/Interview.tsx";
import {JobCoach} from "../pages/jobCoach/JobCoach.tsx";
import {Rentensteuerberater} from "../pages/rentensteuerberater/Rentensteuerberater.tsx";
import {SilverPlus} from "../pages/silverPlus/SilverPlus.tsx";
import {SilverPlusSubscription} from "../pages/silverPlus/SilverPlusSubscription.tsx";
import {CancelSilverPlus} from "../pages/account/CancelSilverPlus.tsx";
import {SilverPlusMembership} from "../pages/account/SilverPlusMembership.tsx";
import {AiPreview} from "../pages/aiPreview/AiPreview.tsx";
import {CvGenerator} from "../pages/cvGenerator/CvGenerator.tsx";


export const AppRouter = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const param2 = searchParams.get('param2');
    const target = searchParams.get('target');
    const id = searchParams.get('id');

    return (
        <Routes>
            {(param2 || id) && target ? (
                <Route path="*" element={<MagicLinkRedirect/>}/>
            ) : (
                <>
                    <Route
                        path={"/"}
                        element={
                            <PrivateRoute redirectTo={"/login"}>
                                <JobPoolNew/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/redirects/:type"
                        element={<MagicLinkRedirect/>}
                    />

                    <Route
                        path={"/login"}
                        element={
                            <PublicRoute>
                                <Login/>
                            </PublicRoute>
                        }
                    />
                    <Route
                        path="/profile"
                        element={
                            <PrivateRoute>
                                <MyProfile/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/jobs/:id"
                        element={
                            <PrivateRoute>
                                <JobDetails/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/messages"
                        element={
                            <PrivateRoute>
                                <Messages/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/messages/:id"
                        element={
                            <PrivateRoute>
                                <Messages/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/details/:id"
                        element={
                            <PrivateRoute>
                                <CandidateMsgDetails/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/account/cancel-silverplus"
                        element={
                            <PrivateRoute>
                                <CancelSilverPlus/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/account/silverplus-membership"
                        element={
                            <PrivateRoute>
                                <SilverPlusMembership/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/account"
                        element={
                            <PrivateRoute>
                                <Account/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/recomendation"
                        element={
                            <PrivateRoute>
                                <Recommendation/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/templates"
                        element={
                            <PrivateRoute>
                                <Templates/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/privacy"
                        element={
                            <PrivateRoute>
                                <Privacy/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/hilfe-kontakt"
                        element={
                            <PrivateRoute>
                                <HilfeKontakt/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/searches"
                        element={
                            <PrivateRoute>
                                <Searches/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/searches/:id"
                        element={
                            <PrivateRoute>
                                <EditSearch/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/personal"
                        element={
                            <PrivateRoute>
                                <Personal/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/desired-jobs"
                        element={
                            <PrivateRoute>
                                <DesiredJobs/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/location"
                        element={
                            <PrivateRoute>
                                <Location/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/education"
                        element={
                            <PrivateRoute>
                                <Education/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/work-history"
                        element={
                            <PrivateRoute>
                                <WorkHistory/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/cv-generator"
                        element={
                            <PrivateRoute>
                                <CvGenerator/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/cv-document"
                        element={
                            <PrivateRoute>
                                <CVDocument/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/delete-profile"
                        element={
                            <PrivateRoute>
                                <DeleteProfile/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/courses"
                        element={
                            <PrivateRoute>
                                <Courses/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/courses/:key"
                        element={
                            <PrivateRoute>
                                <CourseDetails/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/ai-jobs"
                        element={
                            <PrivateRoute>
                                <AiJobs/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/ai-jobs/:sessionId"
                        element={
                            <PrivateRoute>
                                <AiJobs/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/ai-job-web"
                        element={
                            <PrivateRoute>
                                <AiNewJobs/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/cover-letter"
                        element={
                            <PrivateRoute>
                                <CoverLetter/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/cover-letter/:sessionId"
                        element={
                            <PrivateRoute>
                                <CoverLetter/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/interview"
                        element={
                            <PrivateRoute>
                                <Interview/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/interview/:sessionId"
                        element={
                            <PrivateRoute>
                                <Interview/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/job-coach"
                        element={
                            <PrivateRoute>
                                <JobCoach/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/job-coach/:sessionId"
                        element={
                            <PrivateRoute>
                                <JobCoach/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/rentensteuerberater"
                        element={
                            <PrivateRoute>
                                <Rentensteuerberater/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/rentensteuerberater/:sessionId"
                        element={
                            <PrivateRoute>
                                <Rentensteuerberater/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/silverplus"
                        element={
                            <PrivateRoute>
                                <SilverPlus/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/unlock-silverplus"
                        element={
                            <PrivateRoute>
                                <AiPreview/>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/silverplus/subscription"
                        element={
                            <PrivateRoute>
                                <SilverPlusSubscription/>
                            </PrivateRoute>
                        }
                    />
                    <Route path="*" element={<ErrorState/>}/>
                </>
            )}
        </Routes>
    )
}

